<template>
    <div class="fluid">
        <h1 class="app-title">Processamento Arquivos Pagamento</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#004262" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fa fa-search"
                                class="mx-auto"
                                title="Informe os parâmetros da pesquisa">
                            <ParametrosPesquisa
                                    :filtros="filtros"
                                    @consultar="consultar"/>
                        </tab-content>
                        <tab-content
                                icon="fa fa-file-text-o"
                                class="mx-auto"
                                title="Resultado da Pesquisa" >
                            <TabelaPesquisas
                                    :resultado="resultado"
                                    :configTable="configTable"
                                    :filtros="filtros"
                                    :selecteds="selecteds"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @limparFiltros="limparFiltros"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <div v-if="props.activeTabIndex == 0">
                                        <b-button
                                                id="btnProxima"
                                                @click="pesquisar"
                                                variant="primary">
                                            Pesquisar
                                        </b-button>
                                    </div>
                                    <div v-if="props.activeTabIndex == 1">
                                        <b-button
                                                @click="voltar" style="float: left"
                                                variant="secondary">
                                            <i class="fa fa-arrow-left"></i>
                                            Voltar
                                        </b-button>
                                        <b-button class="mx-1 " variant="primary" :disabled="selecteds.length <= 0"  @click.prevent="reprocessar">
                                            <i class="fa fa-refresh" v-if="!loadReprocessar"></i>
                                            <b-spinner small v-if="loadReprocessar"></b-spinner>
                                            Reprocessar
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>

        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import ParametrosPesquisa from "./components/ParametrosPesquisa";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {
            ParametrosPesquisa,
            TabelaPesquisas,
            FormWizard,
            TabContent,
            WizardStep,
            CompFiltroGrid
        },
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                configTable: {
                    perPage: 10,
                    sortField: 'arquivoProcessamento.dataHoraRecebimento',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                    visible: false
                },
                resultado: [],
                selecteds: [],
                loadReprocessar: false,
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoValor: null,
                    campoMascara: null,
                    listaValores: []
                },
                filtros: {
                    dataInicio: null,
                    dataFinal: null,
                    filtrarDataRecebimento: null,
                    dataRecebimento: null,
                    filtrarNomeArquivo: null,
                    nomeArquivo: null,
                    status: null,
                    filtrarErro: null,
                    erro: null
                }
            }
        },
        methods: {
            async pesquisar() {
                this.filtros = {
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    filtrarDataRecebimento: null,
                    dataRecebimento: null,
                    filtrarNomeArquivo: null,
                    nomeArquivo: null,
                    status: null,
                    filtrarErro: null,
                    erro: null
                };

                this.selecteds = [];

                this.$refs.wizard.nextTab();

                this.$store.commit("setMessages", {});

                this.configTable.visible = true;
                this.consultar();
            },
            async voltar() {
                this.$refs.wizard.reset();
            },

            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                let filtrosPesquisa = {
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    filtrarDataRecebimento: this.filtros.filtrarDataRecebimento,
                    dataRecebimento: this.filtros.dataRecebimento,
                    filtrarNomeArquivo: this.filtros.filtrarNomeArquivo,
                    nomeArquivo: this.filtros.nomeArquivo,
                    status: this.filtros.status,
                    filtrarErro: this.filtros.filtrarErro,
                    erro: this.filtros.erro
                };

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/arquivoProcessamento/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.resultado = response.data.resultado;
                    this.configTable.rows = response.data.rows;

                    this.configTable.checkedAll = true;
                    this.resultado.forEach(result => {
                        result.checked = false;
                        this.selecteds.forEach(selected => {
                            if(result.codArquivoProcessamento == selected.codArquivoProcessamento) {
                                const index = this.selecteds.indexOf(selected);
                                this.selecteds.splice(index, 1);

                                this.selecteds.push(result);
                                result.checked = true;
                            }
                        });

                        if(!this.selecteds.includes(result)) {
                            this.configTable.checkedAll = false
                        }
                    });
                }).finally(() => {
                    this.configTable.load = false;
                });
            },
            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Data de Recebimento') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataRecebimento;
                        this.filtro.campoValor = this.filtros.dataRecebimento;
                    } else if(this.filtro.campoFiltro == 'Nome do Arquivo') {
                        this.filtro.filtrarEm = this.filtros.filtrarNomeArquivo;
                        this.filtro.campoValor = this.filtros.nomeArquivo;
                    } else if(this.filtro.campoFiltro == 'Status') {
                        this.filtro.campoValor = this.filtros.status;
                    } else if(this.filtro.campoFiltro == 'Erro') {
                        this.filtro.filtrarEm = this.filtros.filtrarErro;
                        this.filtro.campoValor = this.filtros.erro;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoValor = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'Data de Recebimento') {
                    this.filtros.filtrarDataRecebimento = this.filtro.filtrarEm;
                    this.filtros.dataRecebimento = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Nome do Arquivo') {
                    this.filtros.filtrarNomeArquivo = this.filtro.filtrarEm;
                    this.filtros.nomeArquivo = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Status') {
                    this.filtros.status = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Erro') {
                    this.filtros.filtrarErro = this.filtro.filtrarEm;
                    this.filtros.erro = this.filtro.campoValor;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Data de Recebimento') {
                    this.configTable.sortField = 'arquivoProcessamento.dataHoraRecebimento';
                } else if(this.filtro.campoFiltro == 'Nome do Arquivo') {
                    this.configTable.sortField = 'arquivoProcessamento.nomeArquivo';
                } else if(this.filtro.campoFiltro == 'Status') {
                    this.configTable.sortField = 'arquivoProcessamento.status';
                } else if(this.filtro.campoFiltro == 'Erro') {
                    this.configTable.sortField = 'arquivoProcessamento.erroProcessamento';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    filtrarDataRecebimento: null,
                    dataRecebimento: null,
                    filtrarNomeArquivo: null,
                    nomeArquivo: null,
                    status: null,
                    filtrarErro: null,
                    erro: null
                };

                this.consultar();
            },
            reprocessar() {
                let codigos = [];
                this.selecteds.forEach(d => {
                    codigos.push(d.codArquivoProcessamento);
                });

                this.loadReprocessar = true;
                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/arquivoProcessamento/reprocessar`, codigos, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then((resp) => {
                    if(resp.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${resp.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    this.selecteds = [];
                    this.configTable.checkedAll = false;
                }).finally(() => {
                    this.configTable.currentPage = 1;
                    this.configTable.load = false;
                    this.loadReprocessar = false;
                    this.consultar();
                })
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
        },
    }
</script>
